import { useEffect, useState } from 'react'
import { api, API, ROUTES, TOKEN_KEYS, getToken } from './api'

// Asks the server who you are (GET /users/me) once per login token.
// kind: 'ok' (admin) | 'denied' (server says you are not admin) | 'problem' (token/URL/route issue, see reason)
let cache = { token: null, promise: null }

export function useIsAdmin() {
  const [state, setState] = useState({ loading: true, isAdmin: false, kind: 'ok', reason: '' })

  useEffect(() => {
    const token = getToken()
    if (!token) {
      return setState({
        loading: false, isAdmin: false, kind: 'problem',
        reason: `No login token found in localStorage (looked for: ${TOKEN_KEYS.join(', ')}). Open admin/api.js and put the key your login uses first in TOKEN_KEYS.`,
      })
    }
    if (cache.token !== token) {
      cache = { token, promise: api.get(ROUTES.me).then((u) => ({ role: u?.role })).catch((error) => ({ error })) }
    }
    let live = true
    cache.promise.then((r) => {
      if (!live) return
      if (r.error) {
        cache = { token: null, promise: null } // do not remember failures
        return setState({ loading: false, isAdmin: false, kind: 'problem', reason: `GET ${API}${ROUTES.me} failed${r.error.status ? ` (${r.error.status})` : ''}: ${r.error.message}` })
      }
      const ok = String(r.role).toLowerCase() === 'admin'
      if (ok) return setState({ loading: false, isAdmin: true, kind: 'ok', reason: '' })
      if (r.role === undefined) {
        return setState({ loading: false, isAdmin: false, kind: 'problem', reason: 'GET /users/me did not return a role. In usercontroller.js, change getMe to: select id, name, email, phone, role from users ...' })
      }
      setState({ loading: false, isAdmin: false, kind: 'denied', reason: `Your role is "${r.role}".` })
    })
    return () => {
      live = false
    }
  }, [])

  return state
}
